export class ExternalSignupRequest {
    accessToken: string;
    accessTokenType: string;
    /** Optional Apple or Google id_token (JWT). Required for Auth0 CTE on signup_external; Google also sends access_token separately. */
    idToken?: string;
    externalParams?: {}; // to be expanded on
}
export interface ExternalSignUpIncompleteFormRequest {
    firstName?: string;
    lastName?: string;
    email?: string;
}
